import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import { useAsync } from '@src/redux/hooks/useAsync';
import { SET_CURRENT_FLOW } from './constants';
import { setCurrentFlow } from './action';

const landingSelector = (state) => {
  return state.landing;
};

export const useOnloading = {
  state: () => {
    return useSelect(landingSelector);
  },
  actions: () => {
    return {
      setCurrentFlow: useAction(setCurrentFlow, {
        saga: useAsync(SET_CURRENT_FLOW),
      }),
    };
  },
};
